module.exports = __webpack_public_path__ + "static/media/6.ddf81d69.gif";